<template>
  <div class="shop-main" v-if="salonId" :class="{ _g: !currentLoyalityKind }">
    <span
      class="shop-main__card"
      :class="{
        active: currentLoyalityKind === 'certificate',
        'mb-24px': !currentLoyalityKind,
      }"
      :style="{
        backgroundImage: `url(${
          currentSetDesing ? currentSetDesing : imageCert
        })`,
      }"
      @click="setTypeOfBuy('certificate')"
      v-if="currentLoyalityKind !== 'abonement'"
    >
      <span>Сертификат</span>
    </span>
    <span
      class="shop-main__card"
      :class="{ active: currentLoyalityKind === 'abonement' }"
      :style="{
        backgroundImage: `url(${
          currentSetDesing ? currentSetDesing : imageAbon
        })`,
      }"
      @click="setTypeOfBuy('abonement')"
      v-if="currentLoyalityKind !== 'certificate'"
    >
      <span>Абонемент</span>
    </span>

    <shopForm v-if="currentLoyalityKind"></shopForm>
  </div>
</template>

<script setup lang="ts">
import imageCert from "@/assets/images/certificates.jpeg";
import imageAbon from "@/assets/images/abonements.png";
import "../assets/cedra4f/stylesheet.css";
import "../assets/reset.css";
import shopForm from "@/components/shop-form.vue";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { TypeDesignObj } from "@/types/typesOfApi";

const route = useRoute();

const salonId = route.params.SALON_ID as string | undefined;

const store = useStore();

const currentLoyalityKind = computed(() => store.state.currentLoyalityKind);

const currentSetDesing = computed(() => {
  const allDesingTypes: TypeDesignObj[] = store.state.allDesignTypes;

  if (allDesingTypes) {
    const setDesingId = store.state.loyalityShopData.designType;

    if (setDesingId) {
      return allDesingTypes.find((i: TypeDesignObj) => i.id === setDesingId)
        ?.image;
    } else {
      return null;
    }
  }

  return null;
});

function setTypeOfBuy(loyalityType: string): void {
  if (store.state.currentShopStep === 0) {
    store.state.currentShopStep++;
    store.state.currentLoyalityKind = loyalityType;
  }
}
</script>

<style lang="scss">
$color_1: #dadace;
$color_2: #2e2823;
$color_3: #8f8f8f;
$color_4: #a09c95;
$color_5: #e4c09e;
$background-color_1: #999;
$background-color_2: #4b433c;
$background-color_3: #e0d8c4;
$background-color_4: #a09c95;
$background-color_5: #ece6dc;
$background-color_6: inherit;
$background-color_7: #26201b;
$background-color_8: #6ca475;
$background-color_9: #e4c09e;
$border-color_1: transparent;
$border-color_2: #ece6dc;
$border-color_3: inherit;
$border-color_4: #e4c09e;

.shop-main {
  display: grid;
  grid-gap: 24px;
  min-height: 558px;

  @media (min-width: 1024px) {
    padding: 24px 32px 54px 32px;
    grid-template-columns: 1fr 1fr;
    grid-gap: 24px;
    align-items: flex-start;
  }
  @media (max-width: 1024px) {
    grid-gap: 0;
  }

  &__card {
    text-transform: uppercase;
    cursor: pointer;
    position: relative;
    background-color: $background-color_1;
    font-size: 32px;
    font-weight: 400;
    line-height: 42.88px;
    text-align: center;
    width: 100%;
    height: 100%;
    padding-top: 66%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 24px;
    overflow: hidden;

    transition: 0.5s;
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.33);
      z-index: 0;
      content: "";
    }
    > * {
      position: absolute;
      content: "";
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }

    @media (max-width: 1023px) {
      &.active {
        padding-top: 29%;
        border-radius: 24px 24px 0 0;
        margin-bottom: 0px;
      }
    }
  }
}

._g {
  grid-gap: 24px;
}

.button {
  display: flex;
  cursor: pointer;
  padding: 8px 16px 8px 16px;
  border-radius: 12px;
  border: 1px solid #e0d8c4;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  align-items: center;
  justify-content: center;
}
@media (hover: hover) and (pointer: fine) {
  .button.next:hover,
  .button.back:hover {
    background-color: $background-color_3;
    color: $color_2;
  }
}

._loader {
  position: relative;
  pointer-events: none;
  *:not(br) {
    filter: blur(5px);
  }

  &::after {
    content: "";
    width: 100px;
    height: 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 20;

    transform: translate(-50%, -50%);
    background: url(~@/assets/images/loader2.svg) no-repeat center/cover;
  }

  &._loader-20px::after {
    width: 20px;
    height: 20px;
  }
  &._loader-40px::after {
    width: 40px;
    height: 40px;
  }
  &._loader-left::after {
    left: 0;
    bottom: 10px;
    transform: none;
  }
  &._loader-right::after {
    left: 100%;
    transform: translate(-100%, -50%);
  }
}
</style>
